import { Alert, Backdrop, Box, Button, Checkbox, CircularProgress, Divider, Grid, Icon, Paper, Snackbar, Stack, TextField, Typography } from "@mui/material";
import { PayPalButtons, PayPalScriptProvider, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { useCallback, useEffect, useState } from "react";
import { getUser, logPayment } from "../api/api";
import tarifas_inscripcion from '../pagos/tarifas_inscripcion.json'
import tarifas_giras from '../pagos/tarifas_giras.json'
import tarifas_cena from '../pagos/tarifas_cena.json'

// Custom component to wrap the PayPalButtons and handle currency changes
const ButtonWrapper = ({ currency, showSpinner, amount, callback, userId }) => {

    // usePayPalScriptReducer can be use only inside children of PayPalScriptProviders
    // This is the main reason to wrap the PayPalButtons in a new component
    const [{ options, isPending }, dispatch] = usePayPalScriptReducer();

    useEffect(() => {
        dispatch({
            type: "resetOptions",
            value: {
                ...options,
                currency: currency,
            },
        });
    }, [currency, showSpinner]);


    return (<>
        {(showSpinner && isPending) && <div className="spinner" />}
        <PayPalButtons
            disabled={false}
            forceReRender={[amount, currency]}
            fundingSource={undefined}
            onError={(err) =>
                logPayment(JSON.stringify({
                    'reference': '',
                    'created_at': new Date().toISOString(),
                    'user_id': userId,
                    'status': 'Failed',
                    'message': err
                }))
            }
            createOrder={(data, actions) => {
                return actions.order
                    .create({
                        purchase_units: [
                            {
                                amount: {
                                    currency_code: currency,
                                    value: amount,
                                },
                            },
                        ],
                    })
                    .then((orderId) => {
                        // Your code here after create the order
                        return orderId;
                    });
            }}
            onApprove={function (data, actions) {
                return actions.order.capture().then(function () {
                    // Your code here after capture the order
                    callback(data.orderID)
                    logPayment(JSON.stringify({
                        'reference': data.orderID,
                        'created_at': new Date().toISOString(),
                        'user_id': userId,
                        'status': 'Approved'
                    }))
                });
            }}
        />
    </>
    );
}

const Pagos = () => {
    const callback = useCallback((orderId) => { setCompletedPayment(true); setOrderId(orderId) })
    const [userId, setUserId] = useState('')
    const [orderId, setOrderId] = useState('')
    const [user, setUser] = useState(undefined)
    const [processing, setProcessing] = useState(false)
    const [messages, setMessages] = useState({ status: 0, message: "" });
    const [showPayment, setShowPayment] = useState(false)
    const [completedPayment, setCompletedPayment] = useState(false)
    const [priceCategories, setPriceCategories] = useState(undefined)
    const [dinnerTotal, setDinnerTotal] = useState(0)
    const [tourTotal, setTourTotal] = useState(0)
    const [total, setTotal] = useState(0)

    const handleClose = () => {
        setMessages({ status: 0, message: "" });
    };

    useEffect(() => {

        const callGetUsers = async () => {

            setUser(undefined)

            if (userId !== '') {
                setProcessing(true)
                const response = await getUser(userId);
                if (response.status && response.status === 400) {
                    setMessages({ status: response.status, message: response.message });
                }
                else {
                    if (response.has_payment) {
                        setMessages({ status: 400, message: "El usuario ya ha realizado el pago" });
                    }
                    else {
                        setUser(response)
                    }
                }

                setProcessing(false)
            }
        };

        callGetUsers();
    }, [userId]);

    useEffect(() => {
        setTotal(Number(priceCategories?.price) + Number(tourTotal) + Number(dinnerTotal))
    }, [priceCategories, tourTotal, dinnerTotal]);

    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={messages.message !== ""}
                onClose={handleClose}
            >
                <Alert
                    variant="filled"
                    severity={messages.status === 0 ? "" : messages.status === 200 ? "success" : "error"}
                >
                    {messages.message}
                </Alert>
            </Snackbar>
            <Backdrop in={processing} sx={{ zIndex: 1300 }}>
                <Stack flexDirection='column' alignItems='center'>
                    <CircularProgress sx={{ color: 'rgb(18,161,154)' }} />
                    <Typography variant='subtitle1' sx={{ color: 'white' }}>
                        Procesando
                    </Typography>
                </Stack>
            </Backdrop>
            <Paper elevation={3}>
                {!showPayment && !completedPayment &&
                    <Box display="flex" flexDirection="column">
                        <Box p={1} sx={{ background: '#9CCC60', color: 'white' }}>
                            <Typography variant="h4" className="title">
                                PAGO DE INSCRIPCIÓN
                            </Typography>
                        </Box>
                        <Grid
                            container
                            flexDirection="column"
                            justifyContent="center"
                        >
                            <Grid item>
                                <Box p={1}>
                                    <Typography variant="h3" className="subtitle">
                                        Consulta de usuario registrado
                                    </Typography>
                                </Box>
                                <Box display="flex" p={1}>
                                    <Grid
                                        id="personal"
                                        container
                                        flexDirection="row"
                                        justifyContent="center"
                                        spacing={3}
                                    >
                                        <Grid item>
                                            <Grid container flexDirection="column" spacing={2}>
                                                <Grid item>
                                                    <Box display="flex" alignItems="center">
                                                        <TextField
                                                            id="txt_id"
                                                            variant="outlined"
                                                            label="Número de identificación o pasaporte"
                                                            sx={{ marginLeft: "8px" }}
                                                            className="field"
                                                            onBlur={(event) => {
                                                                setUserId(event.target.value);
                                                            }}
                                                            required
                                                        />
                                                    </Box>
                                                </Grid>
                                                {user && <Grid item>
                                                    <Box display="flex" alignItems="center">
                                                        <TextField
                                                            id="txt_name"
                                                            variant="outlined"
                                                            sx={{ marginLeft: "8px" }}
                                                            className="field"
                                                            value={user.user_name}
                                                            disabled
                                                        />
                                                    </Box>
                                                </Grid>}
                                                {user && <Grid item>
                                                    <Box display="flex" alignItems="center">
                                                        <TextField
                                                            id="txt_role"
                                                            variant="outlined"
                                                            sx={{ marginLeft: "8px" }}
                                                            className="field"
                                                            value={user.user_role}
                                                            disabled
                                                        />
                                                    </Box>
                                                </Grid>}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid id="footer" container item justifyContent="center">
                                <Grid item>
                                    <Box display="flex" p={1}>
                                        <Button
                                            disabled={!user}
                                            sx={{ background: "rgb(18,161,154)" }}
                                            variant="contained"
                                            onClick={() => { setShowPayment(true); setPriceCategories(tarifas_inscripcion.find(x => x.name.toLowerCase() === user?.user_role.toLowerCase())) }}
                                        >
                                            Proceder con el pago
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                }
            </Paper>
            {showPayment && !completedPayment &&
                <>
                    <Paper sx={{ m: 1 }}>
                        <Box p={1} sx={{ background: '#9CCC60', color: 'white' }}>
                            <Typography variant="h4" className="title">
                                CONFIRMACIÓN DE PAGO
                            </Typography>
                        </Box>
                        <Box padding={1}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                Detalle de orden
                            </Typography>
                            <Divider />
                            <Grid container padding={1} sx={{ alignItems: 'center' }}>
                                <Grid item flexGrow={1}>
                                    <Typography variant="subtitle2">
                                        Categoria: {priceCategories?.displayName}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    {priceCategories.price && <Typography variant="subtitle1">
                                        {`$${priceCategories.price}`}
                                    </Typography>}
                                </Grid>
                            </Grid>
                            <Divider />
                            {tarifas_giras && <Grid container padding={1} flexDirection="column">
                                <Grid item>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                        Giras
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    {tarifas_giras.filter(x => x.country === user?.user_country || x.country === "*").map(x => {
                                        return <><Grid container sx={{ alignItems: 'center' }}><Grid item flexGrow={1}>
                                            <Typography variant="subtitle2">
                                                {x.name}
                                            </Typography>
                                        </Grid>
                                            <Grid item>
                                                <Grid container sx={{ alignItems: 'center' }}>
                                                    <Grid item>
                                                        <Checkbox onChange={(event) => {
                                                            setTourTotal(prev => {
                                                                const checked = event.target.checked
                                                                let price = Number(x.price)
                                                                // If checked, sum up previous amount + current price
                                                                if (checked) {
                                                                    return prev + price
                                                                }
                                                                //Subtract if unamrked
                                                                return prev - price
                                                            })
                                                        }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant="subtitle1">
                                                            {`$${x.price}`}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        </>
                                    })}
                                </Grid>
                            </Grid>}
                            <Divider />
                            {tarifas_cena && <Grid container padding={1} flexDirection="column">
                                <Grid item>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                        Cena
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    {tarifas_cena.map(x => {
                                        return <><Grid container sx={{ alignItems: 'center' }}><Grid item flexGrow={1}>
                                            <Typography variant="subtitle2">
                                                {x.name}
                                            </Typography>
                                        </Grid>
                                            <Grid item>
                                                <Grid container sx={{ alignItems: 'center' }}>
                                                    <Grid item>
                                                        <Checkbox onChange={(event) => {
                                                            const checked = event.target.checked
                                                            let price = 0
                                                            if (checked) {
                                                                price = x.price
                                                            }
                                                            setDinnerTotal(price)
                                                        }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant="subtitle1">
                                                            {`$${x.price}`}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        </>
                                    })}
                                </Grid>
                            </Grid>}
                            <Divider />
                            <Grid container padding={2}>
                                <Grid item flexGrow={1}>
                                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                        Total a pagar
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="h5">
                                        {`$${total}`}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                    <Paper sx={{ m: 1, textAlign: 'center' }}>
                        <PayPalScriptProvider
                            options={{ "client-id": "AY1X2FTzBKYJLsKR0jcV5h10tlmDBlRYTvZXbe1co1ls8h69_qkMRwv9tWpa4_tpIyyMWTE6q-0C4QAQ", components: "buttons", currency: "USD" }}>
                            <ButtonWrapper
                                currency="USD"
                                showSpinner={false}
                                amount={total}
                                callback={callback}
                                userId={userId} />
                        </PayPalScriptProvider>
                    </Paper>
                </>
            }

            {
                completedPayment && <Box>

                    <Alert
                        variant="outlined"
                        severity="success"
                        sx={{
                            alignItems: 'center',
                            '& .MuiAlert-icon': {
                                fontSize: '70px'
                            }
                        }}
                    >
                        <Typography variant="h4">
                            Confirmación de pago exitosa.
                        </Typography>
                        <Typography variant="h6">
                            Gracias por confirmar su participación.
                        </Typography>
                        <Typography variant="h6">
                            Número de referencia: {orderId}
                        </Typography>
                    </Alert>
                </Box>
            }

        </>

    );
};

export default Pagos;
